import { render, staticRenderFns } from "./coperparametre.vue?vue&type=template&id=501b0b4e"
import script from "./coperparametre.vue?vue&type=script&lang=js"
export * from "./coperparametre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports